module.exports = __webpack_public_path__ + "img/normal.91561828.svg";